import * as React from "react";
import {CreateAccountPanel} from "./VendorWelcome/CreateAccountPanel";
import {LoginPanel} from "./VendorWelcome/LoginPanel";

import {VendorWrapper} from "./shared/VendorWrapper";

import './VendorWelcome.pcss';
import {useState} from "react";
import {handleSpacePressed} from "utils";

export const VendorWelcome = (props:{loginErrorMessage:string}) => {

  const [showLogin, setShowLogin] = useState(true);


  return (
      <VendorWrapper>
        <div className={'action-columns'}>
          {showLogin ?
              <>
                <LoginPanel loginErrorMessage={props.loginErrorMessage} />
                <div className={'alt-cta'}><h2 className={'level2'}>Need access? <a
                  onClick={()=>{ setShowLogin(false); }}
                  onKeyDown={(e)=>{ handleSpacePressed(e, ()=>{ setShowLogin(false); });}}
                >Create your account</a></h2></div>
              </>
              :
              <>
                <CreateAccountPanel/>
                <div className={'alt-cta'}><h2 className={'level2'}>Already have an account? <a
                  onClick={()=>{ setShowLogin(true); }}
                  onKeyDown={(e)=>{ handleSpacePressed(e, ()=>{ setShowLogin(true); });}}
                >Go to sign in</a></h2></div>
              </>
          }
        </div>
      </VendorWrapper>
  );
}


